// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import LinkInput from './LinkInput';
import LinkStateDisplay from './LinkStateDisplay';

// Styles
import './LinkEditor.scss';

const LinkEditor = (props) => {
    const isLoaded = props.element.getIn(['content', 'link', 'url']);

    if (isLoaded) return null;

    return (
        <div className="LinkEditor">
            <LinkStateDisplay {...props} />
            <LinkInput {...props} />
        </div>
    );
};

LinkEditor.propTypes = {
    element: PropTypes.object,
};

export default LinkEditor;
